import { hexToRgba } from "./utils";

interface SpotlightOrbsProps {
  primaryColor?: string | null;
}

export function SpotlightOrbs({ primaryColor }: SpotlightOrbsProps) {
  const color1 = hexToRgba(primaryColor, 0.15) ?? "rgba(59, 130, 246, 0.15)";
  const color2 = hexToRgba(primaryColor, 0.1) ?? "rgba(147, 51, 234, 0.1)";

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <div
        className="absolute -top-32 -right-32 w-96 h-96 rounded-full blur-3xl animate-float animate-pulse-soft"
        style={{ background: color1 }}
      />
      <div
        className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full blur-3xl animate-float animate-pulse-soft"
        style={{ background: color2, animationDelay: "3s" }}
      />
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 rounded-full blur-3xl animate-pulse-soft"
        style={{ background: color1, animationDelay: "1.5s" }}
      />
    </div>
  );
}
